import * as Preact from "preact"
import Pointer from "poin"

import App from "@fae/source/models/App.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Audiomix from "@fae/source/engine/Audiomix.js"
// import Random from "@fae/source/utility/Random.js"
// const random = new Random()

let UnitSprite = function() {}
import("@fae/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"
import Dice from "@fae/source/data/games/ember/views/Dice.jsx"

import "./UnitManagementSection.less"

const ITEM_COST = 3

export default class UnitManagementSection {
    render() {
        const stage = this.props.stage
        const slotKeys = [0, 1, 2, 3, 4, 5]

        if(stage == undefined) return
        return (
            <div class="UnitManagementSection" direction={this.props.direction || "vertical"}>
                {Object.values(stage.units).filter((unit) => {
                    return unit.affiliation == "good"
                        && unit.isDead != true
                        // AND IS IN CURRENT ZONE
                }).map((unit) => {
                    return (
                        <div class="Unit">
                            <div class="Details">
                                <div class="Status">
                                    <div class="Name">{unit.name}</div>
                                    <div class="Thumbnail">
                                        <UnitSprite unit={unit}/>
                                        <UnitHealthBar unit={unit} maxsegments={20}/>
                                    </div>
                                </div>
                                <div class="Inventory">
                                    <div class="ItemGrid">
                                        {slotKeys.map((slotKey) => {
                                            let item = null
                                            let isDefault = false
                                            if(unit.items != undefined
                                            && unit.items[slotKey] != undefined
                                            && unit.items[slotKey] != window.selectedItem) {
                                                item = unit.items[slotKey]
                                            } else {
                                                item = unit.defaultItems[slotKey]
                                                isDefault = true
                                            }
                                            return (
                                                <div class="Item" isDefault={isDefault}>
                                                    <Dice item={item} index={slotKey}
                                                        onMouseDown={this.onClickUnitItemSlot(stage, unit.key, slotKey, "down")}
                                                        onMouseUp={this.onClickUnitItemSlot(stage, unit.key, slotKey, "up")}
                                                        anchored="bottom"/>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div class="Passives">
                                    <div class="Passive">
                                        <div class="Text">
                                            <span class="Highlighted" element={unit.passives[0]?.element}>
                                                {unit.passives[0]?.title}
                                            </span>
                                            <div class="Description">
                                                {unit.passives[0]?.description()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
    onClickUnitItemSlot(stage, unitKey, itemSlotKey, eventDirection) {
        return function(event) {
            const MOUSE_BUTTON = 0
            if(event.button != MOUSE_BUTTON) return
            const unit = stage.units[unitKey]

            if(eventDirection == "down"
            && window.selectedItem == undefined
            && unit.items != undefined
            && unit.items[itemSlotKey] != undefined) {
                window.selectedItemSlotKey = itemSlotKey
                window.selectedItem = unit.items[itemSlotKey]
                if(unit.equippedItem == unit.items[itemSlotKey]) {
                    unit.equippedItem = undefined
                    Audiomix.trigger("Selection:Start")
                }

                unit.items[itemSlotKey] = undefined
                // console.log("selected", window.selectedItem)


                // "Selection:Start": {
                // "Selection:Finish": {
                // "Selection:Move": {
                // "Selection:Cancel": {
                return
            }

            if((eventDirection == "down" || (eventDirection == "up" && itemSlotKey != window.selectedItemSlotKey))
            && window.selectedItem != undefined
            && unit.items != undefined
            && unit.items[itemSlotKey] == undefined) {
                if(window.selectedItemSlotKey == "merchant") {
                    if(window.goldCount === undefined) return
                    if(window.goldCount < ITEM_COST) return

                    window.goldCount -= ITEM_COST
                    if(window.draftableItems != undefined) {
                        const index = window.draftableItems.indexOf(window.selectedItem)
                        window.draftableItems[index] = null
                    }
                    Audiomix.trigger("Merchant:Coins")

                    window.hasBoughtSomething = true

                    const units = Object.values(stage.units).filter((unit) => unit.affiliation == "good")
                    let items = []
                    units.forEach((unit) => {
                        items = items.concat(Object.values(unit.items))
                    })
                    items = items.filter((item) => item?.title == window.selectedItem?.title)
                    if(items.length >= 2) {
                        window.couldTriple = true
                    }
                }
                // console.log("dropping", window.selectedItem)
                unit.items[itemSlotKey] = window.selectedItem
                unit.equippedItem = window.selectedItem
                window.selectedItemSlotKey = undefined
                window.selectedItem = undefined
                Audiomix.trigger("Selection:Finish")

                if(itemSlotKey % 2 == 0) {
                    if(unit.items[0]?.title != undefined
                    && unit.items[0]?.title == unit.items[2]?.title
                    && unit.items[0]?.title == unit.items[4]?.title) {
                        unit.items[2].power = unit.items[2].power ?? 0
                        unit.items[2].power = Math.max(unit.items[0].power ?? 0, unit.items[2].power ?? 0, unit.items[4].power ?? 0) ?? 0
                        unit.items[2].power *= 2

                        unit.items[0] = undefined
                        unit.items[4] = undefined

                        unit.equippedItem = unit.items[2]

                        window.hasTripled = true
                        Audiomix.trigger("Merchant:Triple")
                    }
                } else {
                    if(unit.items[1]?.title != undefined
                    && unit.items[1]?.title == unit.items[3]?.title
                    && unit.items[1]?.title == unit.items[5]?.title) {
                        unit.items[3].power = unit.items[3].power ?? 0
                        unit.items[3].power = Math.max(unit.items[1].power ?? 0, unit.items[3].power ?? 0, unit.items[5].power ?? 0) ?? 0
                        unit.items[3].power *= 2

                        unit.items[1] = undefined
                        unit.items[5] = undefined

                        unit.equippedItem = unit.items[3]

                        window.hasTripled = true
                        Audiomix.trigger("Merchant:Triple")
                    }
                }
            }

            // if(window.selectedChest == undefined) return
            // const chestItem = window.selectedChest.equipment.items[0]
            // if(unit.equippableWeapons?.includes(chestItem.weaponType) == false) return
            // stage.units[unit.key].items[itemSlotKey] = window.selectedChest.equipment.items[0]
            // // unit.items[itemSlotKey] = window.selectedChest.equipment.items[0]
            // window.selectedChest = undefined
        }
    }
}
